export const tripStatuses = {
	tripStatus: [
		{ value: '1', label: 'Open' },
		{ value: '0', label: 'Closed' },]
}

export default tripStatuses